import type { SubscriptionTier } from '../client'

export type Billing = 'monthly' | 'yearly'

export type PlanCopy = {
  name: string
  tier: SubscriptionTier | null
  desc: string
  features: string[]
  cta: string
  popular?: boolean
}

export const YEARLY_DISCOUNT = 0.2

export const DEMO_URL = 'https://calendly.com/adlovin-support/30min'

export const PLAN_COPY: PlanCopy[] = [
  {
    name: 'Starter',
    tier: 'starter',
    desc: 'For solo operators, creators, and founders.',
    features: [
      '1 brand',
      '150 ads/month',
      '5 competitors tracked',
      'Inline editor',
      'All placements',
      'Email support',
    ],
    cta: 'Start free trial',
  },
  {
    name: 'Growth',
    tier: 'growth',
    desc: 'For DTC brands and in-house teams.',
    features: [
      '5 brands',
      '800 ads/month',
      'Unlimited competitor spy',
      'Brand Lock',
      '1-click Meta push',
      'Priority chat support',
    ],
    cta: 'Start free trial',
    popular: true,
  },
  {
    name: 'Scale',
    tier: 'scale',
    desc: 'For agencies and multi-brand teams.',
    features: [
      '25 brands (white-label)',
      'Unlimited ads',
      'Client workspaces & approvals',
      'All integrations unlocked',
      'Dedicated Slack channel',
      'Onboarding session',
    ],
    cta: 'Start free trial',
  },
  {
    name: 'Enterprise',
    tier: null,
    desc: 'For enterprise teams with custom workflows.',
    features: [
      'Unlimited everything',
      'SSO / SAML',
      'Custom integrations',
      'DPA + security review',
      'Dedicated CSM',
      'SLA-backed support',
    ],
    cta: 'Talk to sales',
  },
]

export const TIER_NAMES: Record<SubscriptionTier, string> = {
  none: 'No plan',
  starter: 'Starter',
  growth: 'Growth',
  scale: 'Scale',
  enterprise: 'Enterprise',
}

export const intervalFor = (billing: Billing) => (billing === 'yearly' ? 'year' : 'month')

/** A yearly charge grants the whole year's credits up front. */
export const creditsFor = (monthlyCredits: number, billing: Billing) =>
  billing === 'yearly' ? monthlyCredits * 12 : monthlyCredits
